import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Icon from './Icon'

interface NavItemProps {
  label: string
  icon: string
  iconStyle?: string
  href?: string
  disabled?: boolean
}

const NavItem = ({ label, icon, href = '', disabled = false }: NavItemProps) => {
  const [isActive, setIsActive] = useState(false)

  const { pathname } = useLocation()

  useEffect(() => {
    setIsActive(!disabled && window.location.pathname === href)
  }, [disabled, href, pathname])

  const className = `nav-item-link${isActive ? ' active' : ''}${disabled ? ' disabled' : ''}${href === '' ? ' disabled-links' : ''}`

  return (
    <li className={`nav-item`}>
      {disabled ? (
        <span className={className} aria-disabled="true">
          <Icon name={icon} />
          <span className="nav-item-label">{label}</span>
        </span>
      ) : (
        <Link className={className} to={href}>
          <Icon name={icon} />
          <span className="nav-item-label">{label}</span>
        </Link>
      )}
    </li>
  )
}

export default NavItem
